// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"4a393b0a","453":"1cfcca56"}[chunkId] + ".chunk.js";
};